// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:31:35

export default {
  "id": "gem-deep-digger",
  "slug": "gem-deep-digger",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/df82edd9f8954cefbfed8928d0035e9b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/df82edd9f8954cefbfed8928d0035e9b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Gem Deep Digger",
      "description": "Dive deep into the underground world of Gem Deep Digger. In a fun and addictive simulation game,you dig, collect, and upgrade to uncover hidden treasures. With simple one-button controls, anyone can become the ultimate miner. Use your dig to carve through layers of dirt and rock, uncovering sparkling gems in the ground.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "arcade",
        "dig",
        "treasure"
      ]
    },
    "zh-CN": {
      "title": "宝石深挖者",
      "description": "深入挖掘宝石深挖者的地下世界。在这个有趣且上瘾的模拟游戏中，你挖掘、收集和升级，以揭示隐藏的宝藏。通过简单的单键控制，任何人都能成为终极矿工。使用你的挖掘工具穿透土层和岩石，揭示地面下的闪亮宝石。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "模拟"
      ],
      "tags": [
        "街机",
        "挖掘",
        "宝藏"
      ]
    },
    "zh-TW": {
      "title": "珍寶深挖掘者",
      "description": "深入探索寶石深挖者的地底世界。在這款有趣且上癮的模擬遊戲中，你挖掘、收集和升級，以挖掘隱藏的寶藏。簡單的一鍵控制，讓任何人都能成為最終的礦工。利用你的挖掘工具，穿過層層泥土和岩石，發現地下閃耀的寶石。",
      "instructions": "用滑鼠點擊或觸控以遊玩",
      "genres": [
        "模擬"
      ],
      "tags": [
        "電玩城",
        "挖掘",
        "寶藏"
      ]
    },
    "zh-HK": {
      "title": "寶石深挖者",
      "description": "深入探索寶石深挖者的地底世界。在這款有趣且上癮的模擬遊戲中，你挖掘、收集和升級，以發現隱藏的寶物。簡單的一鍵控制，讓人人都能成為最終的礦工。利用你的挖掘工具，穿過層層泥土和岩石，發現地下的閃耀寶石。",
      "instructions": "滑鼠點擊或輕觸以開始遊戲",
      "genres": [
        "模擬"
      ],
      "tags": [
        "街機",
        "挖掘",
        "財寶"
      ]
    },
    "ja": {
      "title": "ジェムディープダイバー",
      "description": "Gem Deep Diggerの地下世界に深く潜り込もう。楽しい魅力的なシミュレーションゲームで、掘り、収集、アップグレードして隠された宝物を発見しよう。シンプルな一ボタン操作で、誰でも究極の鉱夫になることができる。あなたの掘りを利用して土と岩の層を切り開き、地中の輝く宝石を発見しよう。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "アーケード",
        "掘る",
        "宝物"
      ]
    },
    "ko": {
      "title": "가emm 딥 디그GER",
      "description": "깊은 지하 세계에서 탐험할 수 있는 'ج임 딥 디거'에 뛰어들어 보세요. 재미있고 매력적인 시뮬레이션 게임에서, 파괴하고 수집하고 업그레이드하여 숨겨진 보물을 발견하세요. 간단한 한 버튼 조작으로 누구나 최고의 광부가 될 수 있습니다. 캘리브레이터를 사용하여 토양과 돌의 층을 파괴하여 토지 속에서 빛나는 보석을 발견하세요.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "아케이드",
        "파괴",
        "보물"
      ]
    },
    "fr": {
      "title": "Gem Deep Digger",
      "description": "Plongez au cœur du monde souterrain de Gem Deep Digger. Dans un jeu de simulation amusant et accrocheur, vous creusez, collectez et améliorez pour découvrir des trésors cachés. Avec des commandes simples à un bouton, tout le monde peut devenir le mineur ultime. Utilisez votre creuseuse pour percer à travers les couches de terre et de roche, découvrant des gemmes scintillantes enfouies sous terre.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "arcade",
        "creuser",
        "trésor"
      ]
    }
  }
};
